var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loadingTrue
    ? _c(
        "div",
        {
          ref: "scrollMain",
          class: [_vm.language == "en" ? "en" : "", "app-container-sitc"],
          staticStyle: { "padding-bottom": "0px", "padding-top": "0px" },
        },
        [
          _c(
            "div",
            {
              staticClass: "container-content filter-container-content",
              staticStyle: {
                height: "48px",
                display: "flex",
                "align-items": "center",
              },
            },
            [
              _vm._l(_vm.navTabList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "tab_text",
                    class: { selected: _vm.selectedIndex === index },
                    on: {
                      click: function ($event) {
                        return _vm.selectTab(index)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n         " +
                        _vm._s(
                          _vm.language === "zh" ? item.name : item.nameEn
                        ) +
                        "\n         "
                    ),
                    index < _vm.navTabList.length - 1
                      ? _c("div", { staticClass: "tab_text_border" })
                      : _vm._e(),
                  ]
                )
              }),
              _vm._v(" "),
              !_vm.validateNull(_vm.form.webBkExtendComs) &&
              _vm.form.webBkExtendComs[0].singleContainerFlag === 1
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        color: "red",
                        "margin-left": "60px",
                        "font-size": "16px",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.form.webBkExtendComs[0].singleFlag === 1
                            ? _vm.$t("home.chargeInfoTips1")
                            : _vm.form.webBkExtendComs[0].maxTeusLimit ===
                                null ||
                              _vm.form.webBkExtendComs[0].maxTeusLimit === 0
                            ? ""
                            : _vm.language === "zh"
                            ? _vm.$t("home.chargeInfoTips2") +
                              " " +
                              _vm.form.webBkExtendComs[0].maxTeusLimit
                            : _vm.form.webBkExtendComs[0].maxTeusLimit +
                              " " +
                              _vm.$t("home.chargeInfoTips2")
                        ) + " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.status || _vm.form.status == 0
                ? _c("bookingStatus", {
                    staticClass: "main-status",
                    attrs: {
                      bookingList: _vm.bookingStatusList,
                      status: Number(_vm.form.status),
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: { "padding-bottom": "50px", "margin-top": "60px" },
              attrs: {
                inline: true,
                rules: _vm.rules,
                "label-position": "top",
                model: _vm.form,
                disabled: _vm.isDisable,
              },
            },
            [
              _c("bookingMain", {
                ref: "bookingMain",
                attrs: {
                  isDisable: this.isDisable,
                  id: "basicInfo",
                  form: _vm.form,
                  rules: _vm.rules,
                  packageTypeList: _vm.packageTypeList,
                  paidTypeList: _vm.paidTypeList,
                  cargoList: _vm.cargoList,
                  bookingTypeList: _vm.bookingTypeList,
                  transportationTermsList: _vm.transportationTermsList,
                  preLockFlag: _vm.preLockFlag,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                  },
                  attrs: { id: "consignerInfo" },
                },
                [
                  _c("consignerInfo", {
                    ref: "consignerInfo",
                    staticStyle: { width: "49%" },
                    attrs: {
                      isDisable: this.isDisable,
                      form: _vm.form,
                      rules: _vm.rules,
                    },
                  }),
                  _vm._v(" "),
                  _c("consignerReceiveInfo", {
                    ref: "consignerReceiveInfo",
                    staticStyle: { width: "49%" },
                    attrs: {
                      isDisable: this.isDisable,
                      form: _vm.form,
                      rules: _vm.rules,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                  },
                  attrs: { id: "consignerInfo" },
                },
                [
                  _c("consignerInfoOne", {
                    ref: "consignerInfoOne",
                    staticStyle: { width: "49%" },
                    attrs: {
                      isDisable: this.isDisable,
                      form: _vm.form,
                      rules: _vm.rules,
                    },
                  }),
                  _vm._v(" "),
                  _c("consignerInfoTwo", {
                    ref: "consignerInfoTwo",
                    staticStyle: { width: "49%" },
                    attrs: {
                      isDisable: this.isDisable,
                      form: _vm.form,
                      rules: _vm.rules,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.pol
                ? _c("bookCargo", {
                    ref: "bookCargo",
                    attrs: {
                      "is-disable": this.isDisable,
                      isShowUnload: true,
                      id: "cargoInfo",
                      formInfo: _vm.form,
                      rules: _vm.rules,
                      isShow: true,
                      preLockFlag: _vm.preLockFlag,
                      "show-cargo-info": _vm.showCargoInfo,
                      topBlInfo: _vm.topBlInfo,
                    },
                    on: { openDialog: _vm.openDialog },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("dropTitle", {
                ref: "dropTitle",
                attrs: {
                  form: _vm.form,
                  rules: _vm.rules,
                  containerTypeList: _vm.containerTypeList,
                  cargoList: _vm.cargoList,
                  preLockFlag: _vm.preLockFlag,
                },
              }),
              _vm._v(" "),
              _vm.form.pol
                ? _c("boxInfo", {
                    ref: "boxInfo",
                    attrs: {
                      isDisable: this.isDisable,
                      id: "boxInfo",
                      form: _vm.form,
                      rules: _vm.rules,
                      bookingId: _vm.bookingId,
                      containerTypeList: _vm.containerTypeList,
                      cargoList: _vm.cargoList,
                      directionList: _vm.directionList,
                      containerStatusList: _vm.containerStatusList,
                      preLockFlag: _vm.preLockFlag,
                      topBlInfo: _vm.topBlInfo,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form",
                { attrs: { disabled: true } },
                [
                  _c("bookInfo", {
                    ref: "bookInfo",
                    attrs: {
                      isDisable: this.isDisable,
                      showdisabled: true,
                      isSupplyDisabled: true,
                      id: "otherInfo",
                      isFeed: false,
                      form: _vm.form,
                      rules: _vm.rules,
                      containerTypeList: _vm.containerTypeList,
                      containerSizeList: _vm.containerSizeList,
                      lineTypeList: _vm.lineTypeList,
                      directionList: _vm.directionList,
                      packageTypeList: _vm.packageTypeList,
                      packageDescList: _vm.packageDescList,
                      fullEmptyTypeList: _vm.fullEmptyTypeList,
                      contactTypeCodeList: _vm.contactTypeCodeList,
                      preLockFlag: _vm.preLockFlag,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-container-content" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              class: { reqired: _vm.form.pol.startsWith("KR") },
                              attrs: {
                                prop: "remark",
                                label: _vm.$t("home.remark"),
                              },
                            },
                            [
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "byte-length",
                                    rawName: "v-byte-length",
                                    value: 2000,
                                    expression: "2000",
                                  },
                                  { name: "uppercase", rawName: "v-uppercase" },
                                  { name: "trim", rawName: "v-trim" },
                                  { name: "fth", rawName: "v-fth" },
                                ],
                                attrs: {
                                  type: "textarea",
                                  onblur:
                                    "this.value = this.value.toUpperCase().trim().replace(/[ \\t]*(\\n|\\r\\n)[ \\t]*/g, '$1')",
                                  autosize: { minRows: 3, maxRows: 5 },
                                  disabled: _vm.preLockFlag,
                                },
                                nativeOn: {
                                  dblclick: function ($event) {
                                    return _vm.openDialog(
                                      _vm.form.remark,
                                      3,
                                      2000
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.form.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "remark", $$v)
                                  },
                                  expression: "form.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "priceRemark",
                                label: _vm.$t("home.priceRemark"),
                              },
                            },
                            [
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "byte-length",
                                    rawName: "v-byte-length",
                                    value: 500,
                                    expression: "500",
                                  },
                                  { name: "uppercase", rawName: "v-uppercase" },
                                  { name: "trim", rawName: "v-trim" },
                                  { name: "fth", rawName: "v-fth" },
                                ],
                                attrs: {
                                  type: "textarea",
                                  onblur:
                                    "this.value = this.value.toUpperCase().trim().replace(/[ \\t]*(\\n|\\r\\n)[ \\t]*/g, '$1')",
                                  autosize: { minRows: 3, maxRows: 5 },
                                  disabled: _vm.preLockFlag,
                                },
                                nativeOn: {
                                  dblclick: function ($event) {
                                    return _vm.openDialog(
                                      _vm.form.priceRemark,
                                      4,
                                      500
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.form.priceRemark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "priceRemark", $$v)
                                  },
                                  expression: "form.priceRemark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.validateNull(_vm.form.webBkChargeDetailComs)
                ? _c(
                    "div",
                    {
                      staticClass: "filter-container-content",
                      attrs: { id: "chargeInfo" },
                    },
                    [
                      _c("div", { staticClass: "filter-container-title" }, [
                        _c("div", [_vm._v(_vm._s(_vm.$t("home.chargeInfo")))]),
                      ]),
                      _vm._v(" "),
                      _c("chargeInfo", {
                        ref: "chargeInfo",
                        staticStyle: { width: "49%" },
                        attrs: { form: _vm.form },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isDisable
            ? _c(
                "div",
                {
                  staticClass: "bottom-button",
                  staticStyle: {
                    height: "50px",
                    "line-height": "50px",
                    background: "#fff",
                    "padding-left": "20px",
                  },
                },
                [
                  _vm.isCanSave
                    ? _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleSave(13)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("home.buttonAdd")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isCanSaveDraft
                    ? _c(
                        "el-button",
                        {
                          staticClass: "btn-plain-primary",
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.handleSaveDraft(14)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("home.buttonSaveCopy")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-plain-primary",
                      on: { click: _vm.handleCloseLast },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.close")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("copyBook", {
            ref: "copyBook",
            attrs: {
              width: "50%",
              copyId: _vm.copyId,
              visible: _vm.copyVisible,
            },
            on: {
              "update:visible": function ($event) {
                _vm.copyVisible = $event
              },
            },
          }),
          _vm._v(" "),
          _c("sailSchedule", {
            ref: "sailSchedule",
            attrs: {
              "destroy-on-close": true,
              width: "70%",
              visible: _vm.sailScheduleDialogVisible,
            },
            on: {
              selectionChange: _vm.selectionChange,
              "update:visible": function ($event) {
                _vm.sailScheduleDialogVisible = $event
              },
            },
          }),
          _vm._v(" "),
          _c("message-input-text", {
            ref: "myDialog",
            attrs: { catalogContent: _vm.dialogContent },
            on: {
              "update:catalogContent": function ($event) {
                _vm.dialogContent = $event
              },
              "update:catalog-content": function ($event) {
                _vm.dialogContent = $event
              },
              confirm: _vm.confirm,
            },
          }),
          _vm._v(" "),
          _c("validCustomerInfoDialog", {
            ref: "validCustomerInfoDialog",
            attrs: {
              width: "60%",
              validCustomerTips: _vm.validCustomerTips,
              visible: _vm.validCustomerInfoVisible,
            },
            on: {
              "update:visible": function ($event) {
                _vm.validCustomerInfoVisible = $event
              },
            },
          }),
          _vm._v(" "),
          _c("validateContainerNoDialog", {
            ref: "validateContainerNoDialog",
            attrs: {
              width: "60%",
              validateMsg: _vm.validateContainerNoMsg,
              visible: _vm.validateContainerNoVisible,
            },
            on: {
              handleSave: function ($event) {
                return _vm.handleSave(_vm.saveIndex)
              },
              "update:visible": function ($event) {
                _vm.validateContainerNoVisible = $event
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }